import { EmptyAccountPropsFactory, IAccountProps } from '@/entities/Account'
import { IMenuProps } from '@/entities/Menu'
export interface IAppState {
  layout: string
  loading: boolean
  signup: IAccountProps
  progress: number
  errors: any
  drawer: boolean | null
  alert: boolean | null
  current?: IMenuProps
  redirect: string | null
  from?: string | null
  back?: string | null
  toolbar: boolean
  extension: boolean
  initialize: string | null
  bottom: boolean
  bottomHeight: string
  headerHeight: string
  observer: any
}

export const state = (props?: Partial<IAppState>): IAppState => ({
  layout: 'default',
  loading: false,
  signup: EmptyAccountPropsFactory(),
  progress: 0,
  errors: {},
  drawer: null,
  alert: false,
  current: undefined,
  redirect: null,
  from: null,
  back: null,
  toolbar: false,
  extension: false,
  initialize: null,
  bottom: true,
  bottomHeight: '0px',
  headerHeight: '0px',
  observer: null,
  ...props
})

export default state
